module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Insight Details","btnOk":"Ok, got it!"},"es":{"title":"Detalles del Insight","btnOk":"¡Entendido!"}}')
  delete Component.options._Ctor
}
